import type { UserReportStatus } from '@tabbio/types';

export function createUserReportRequestId(): string {
  const runtimeCrypto = globalThis as typeof globalThis & {
    crypto?: { randomUUID?: () => string };
  };
  if (typeof runtimeCrypto.crypto?.randomUUID === 'function') {
    return runtimeCrypto.crypto.randomUUID();
  }

  // Hermes can run without Web Crypto in older native builds. This value is
  // only a retry key, not a secret or an authorization token.
  return `report-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 14)}`;
}

export function isUserReportOpen(status: UserReportStatus): boolean {
  return status === 'pending' || status === 'reviewing';
}

export function userReportStatusTone(
  status: UserReportStatus,
): 'neutral' | 'info' | 'success' {
  if (status === 'reviewing') return 'info';
  if (status === 'actioned') return 'success';
  return 'neutral';
}
